import React from "react";
import { Col, Image, Layout, Row, Space } from "antd";
import styles from "./detail/FacilityDetail.module.scss";
import publishedFacilityStyles from "./PublishedFacility.module.scss";
import usePublishedId from "@/pages/facilities/hooks/usePublishedId";
import { useGetPublishedIdDetail } from "@/hooks/useFacilities";
import axios from "axios";
import Utilities from "@/pages/facilities/detail/Utilities/Utilities";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import NotFound from "@/components/AppRouter/NotFound";
import TopBarProgress from "react-topbar-progress-indicator";
import { Header } from "antd/es/layout/layout";
import logo from "@/assets/root-logo.png";

function PublishedFacility() {
  const publishedId = usePublishedId();

  axios.interceptors.request.use(
    async (config) => {
      config.headers["Authorization"] = `Basic ${publishedId}`;

      return config;
    },
    (error) => Promise.reject(error)
  );

  const { data, isLoading, isError } = useGetPublishedIdDetail(!!publishedId);

  const companyName = data?.company_name;
  const facilityId = data?.facility_id;
  const { year } = useDashboardYear();

  return (
    <div>
      {isLoading ? (
        <TopBarProgress />
      ) : isError ? (
        <NotFound />
      ) : (
        <>
          <Layout
            className="layout"
            hasSider
          >
            <Header style={{ background: "#F0F2F5", width: "100%" }}>
              <Row justify={"space-around"}>
                <Col>
                  <Image
                    src={logo}
                    preview={false}
                    alt="root-logo"
                    height={27}
                    width={104}
                  />
                </Col>
              </Row>
            </Header>
          </Layout>
          <Row className={publishedFacilityStyles.container}>
            <Col
              span={8}
              className={publishedFacilityStyles.left}
            >
              <Space direction={"vertical"}>
                <span className={publishedFacilityStyles.title}>
                  <b>{companyName}</b> data collection
                </span>
                <span className={publishedFacilityStyles.description}>
                  Please provide all relevant data so that {companyName} can calculate their
                  environmental and carbon footprint.
                </span>
              </Space>
            </Col>
            <Col
              span={16}
              className={publishedFacilityStyles.right}
            >
              <div className={styles.facility}>
                <div className={styles.right}>
                  <div className={styles.utilitiesContainer}>
                    {year && facilityId && (
                      <Utilities
                        facilityId={facilityId}
                        year={year}
                        company_name={companyName}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default PublishedFacility;
